// import logo from './logo.svg';
import './App.css';
import React from "react";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Announcement from "./components/Announcement";
import StudentCard from './components/StudentCard';
import StudentList from "./components/StudentList";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Header />
      <Announcement />
      <StudentCard/>
      <StudentList />
      <Footer />
    </>
  );
}

export default App;
